module.exports = __webpack_public_path__ + "static/media/pen_ink.d66963d6.jpg";